import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Button, Container, Divider, Grid, Header, Input, InputOnChangeData, Message, Segment } from "semantic-ui-react";
import * as Ordini from '..';
import { ApplicationState } from '../..';
import Notification from '../../notification';
import { OrdineRiga } from '../models';
import RiepilogoOrdine from './RiepilogoOrdine';

type OwnProps = {
    onGoBack: (step: number) => void
}

const connector = connect(
    (state: ApplicationState) => ({
        userEmail: state.core.auth.user!.profile.email!,
        carrelloConsumabili: state.ordini.carrelloConsumabili,        
        referenteObbligatorio: state.core.anagrafiche.anagrafica!.referente,
    }),
    Ordini.actions
)
type PropsFromRedux = ConnectedProps<typeof connector>

type RiepilogoProps =
    PropsFromRedux &
    OwnProps

type RiepilogoState = {
    email: string,
    isEmailValid: boolean,
    referente: string,
    isReferenteValid: boolean,
}

class Riepilogo extends React.Component<RiepilogoProps, RiepilogoState> {
    constructor(props: RiepilogoProps) {
        super(props);

        this.state = {
            email: props.userEmail || '',
            isEmailValid: true,
            referente: '',
            isReferenteValid: props.referenteObbligatorio ? false : true,
        };

        this.onSendOrdine = this.onSendOrdine.bind(this);

        this.onEmailChange = this.onEmailChange.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
    }

    render() {
        const { onGoBack } = this.props;
        return (
            <Grid.Row>
                <Grid.Column computer='7' tablet='14' mobile='16'>
                    <Message
                        icon="inbox"
                        header="Invia l'ordine dei seguenti materiali"
                        content="Prima di inviare verifica i dati del tuo ordine."
                    />
                    <Divider hidden />
                    <Header as='h5' attached='top' block>Informazioni selezionate</Header>
                    <RiepilogoOrdine attached />
                    <Divider hidden />
                    <Header as='h5' attached='top' block>Indirizzo di posta elettronica dove ricevere la conferma di presa in carico dell'ordine </Header>
                    <Segment attached>
                        <Input
                            fluid
                            label={{ icon: 'at' }}
                            error={!this.state.isEmailValid}
                            labelPosition="left corner"
                            placeholder="Indirizzo posta"
                            value={this.state.email}
                            onChange={this.onEmailChange}
                        />
                        <Divider hidden />
                        <Input
                            fluid
                            label={{ icon: 'info' }}
                            error={!this.state.isReferenteValid}
                            labelPosition="left corner"
                            placeholder="Referente"
                            value={this.state.referente}
                            onChange={this.onReferenteChange}
                        />
                    </Segment>
                    <Divider hidden />
                    <Container textAlign='center'>
                        <Button content='Indietro' primary onClick={() => onGoBack(1)} style={{ marginRight: 15 }} />
                        <Button content="Invia ordine" icon="mail outline" primary onClick={this.onSendOrdine} />
                    </Container>
                </Grid.Column>
            </Grid.Row>
        );
    }

    onSendOrdine(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();

        var message = '';
        if (!this.state.isEmailValid) {
            message = "L'indirizzo di mail specificato non è valido. \n";
        }
        if (!this.state.isReferenteValid) {
            message += "Aggiungere il referente. \n";
        }

        if (!this.isNullOrWhitespace(message)) {
            Notification.error(message, 'Dati non validi');
            return;
        }

        const { carrelloConsumabili } = this.props;
        const matricole = Object.keys(carrelloConsumabili);

        if (matricole.length === 0) {
            Notification.error("Nessuna macchina specificata per effettuare l'ordine.", 'Dati non validi');
            return;
        }

        var righe: Array<OrdineRiga> = [];
        this.props.carrelloConsumabili.lista
            .forEach(consumabile => consumabile.righe
                .map(riga => righe.push(riga)));
        //const righeOrdine = this.props.carrelloConsumabili.lista
          //  .map(elemento => elemento.righe);
        //const dettagli = [];
        //_.forEach(matricole, matricola => dettagli.push(Object.assign({}, carrelloConsumabili[matricola], { matricola })));

        this.props.saveOrdine({
            inviaMail: true,
            email: this.state.email,
            referente: this.state.referente,
            righe: righe
        });
    }

    onEmailChange(_: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) {
        let isEmailValid = true;
        if (!this.validateEmail(String(data.value))) {
            isEmailValid = false;
        }

        this.setState({ email: data.value, isEmailValid });
    }

    validateEmail(email: string) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    onReferenteChange = (_: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        let isReferenteValid = true;
        if (this.props.referenteObbligatorio && this.isNullOrWhitespace(data.value)) {
            isReferenteValid = false;
        }

        this.setState({ referente: data.value, isReferenteValid });
    }

    isNullOrWhitespace = (input: string) => {
        return !input || !input.trim();
    }
}

export default connector(Riepilogo);